// Global
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { classnames } from 'tailwindcss-classnames';
// Components
import Container from 'components/helpers/Container';
import PlaceholderWrapper from 'components/helpers/PlaceholderWrapper/PlaceholderWrapper';
import { Components } from '.generated/templates/Feature.Components.model';
import Heading, { propsFromFields } from 'components/helpers/Heading';
import { MissingDataSource } from 'components/helpers/EditingHelpText';

export type LayoutFourColumnProps = Sitecore.Override.ComponentBase &
  Components.Layout.Fields.ColumnLayout;

export type LayoutFourColumnShellProps = {
  first: JSX.Element;
  second: JSX.Element;
  third: JSX.Element;
  fourth: JSX.Element;
};

export const LayoutFourColumnShell = ({
  first,
  second,
  third,
  fourth,
}: LayoutFourColumnShellProps): JSX.Element => {
  const columnCss = classnames('col-span-1', 'mb-10', 'md:mb-0');
  return (
    <div className={classnames('md:grid', 'grid-cols-4', 'md:gap-5', 'lg:gap-7')}>
      <div className={columnCss}>{first}</div>
      <div className={columnCss}>{second}</div>
      <div className={columnCss}>{third}</div>
      <div className={columnCss}>{fourth}</div>
    </div>
  );
};

const LayoutFourColumn = ({ rendering, fields }: LayoutFourColumnProps): JSX.Element => {
  if (fields === null || fields === undefined) {
    return <MissingDataSource />;
  }

  const headingProps = propsFromFields(fields);

  return (
    <Container size="standard" dataComponent="authorable/layout/layout-four-column">
      <div className={fields?.description.value ? classnames('mb-8') : ''}>
        <Heading {...headingProps} descriptionClassName={classnames('text-base')} />
      </div>
      <LayoutFourColumnShell
        first={<PlaceholderWrapper name="nmdp-one-fourth-first" rendering={rendering} />}
        second={<PlaceholderWrapper name="nmdp-one-fourth-second" rendering={rendering} />}
        third={<PlaceholderWrapper name="nmdp-one-fourth-third" rendering={rendering} />}
        fourth={<PlaceholderWrapper name="nmdp-one-fourth-fourth" rendering={rendering} />}
      />
    </Container>
  );
};

export default LayoutFourColumn;
